<template>
    <div class="global-header">
        <div class="nav-top-mask">
            <div class="nav-user-content">
                <div class="user-content">
                    <div v-if="isNexus.includes('languageoperation')">
                        <button 
                                @click="changeLanType('simple')">
                            简体
                        </button>
                        <span>/</span>
                        <button 
                                @click="changeLanType('traditional')">
                            繁體
                        </button>
                    </div>
                    <div class="extensionTopUrls">
                        <button v-for="(item,index) in extensionTopUrls"
                                :key="index"
                                @click="navItemClick(item,index)"
                                >
                            {{ langTransfer(item.text) }}
                        </button>
                    </div>
                </div>
                <div class="user-area">
                        <div class="login-user" v-if="isNexus.includes('login')">
                                <div v-if="userInfos"
                                     class="user-infos"
                                     @click="showMoreActvies = !showMoreActvies">
                                    <!-- <div :style="{ backgroundImage: `url(${userInfos.avatar})` }"
                                         class="user-avatar"/> -->
                                    <p>{{ userInfos.NickName ? userInfos.NickName : userInfos.LoginName }}</p>
                                    <div :style="{transform: showMoreActvies? 'rotate(180deg)':''}"
                                         class="select-icon"/>
                                    <div :class="{ 'more-actives-showed': showMoreActvies }"
                                         class="more-actives-mask">
                                        <div class="more-actives">
                                            <button v-for="(item,index) in moreActives"
                                                    :key="index"
                                                    :style="{background: hoverActivesIndex === index ? themeColor : ''}"
                                                    @mouseenter="hoverActivesIndex = index"
                                                    @mouseleave="hoverActivesIndex = -1"
                                                    @click="moreActivesClick(item)">
                                                {{ langTransfer(item.text) }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <button v-else @click="showLoginRegister" :style="{backgroundImage:enableCastLogin?`url(${carsiimg})`:'unset','background-size': '100% 100%',
                                    'background-position': 'center',
                                    'height': '22px',
                                    'width': '89px',
                                    'vertical-align':enableCastLogin?'sub':'unset'}">
                                    <template v-if="!enableCastLogin">
                                        {{ langTransfer('登录') }}
                                    </template>
                                </button>
                        </div>
                        <div class="usercollection">
                            <button @click="goMine('collection')" v-if="isNexus.includes('mycollection')">
                                 {{ langTransfer('我的收藏') }}
                            </button>
                            <button @click="goMine('bookCase')"
                                     v-if="isNexus.includes('mybookcase')">
                                {{ langTransfer('我的书架') }}
                            </button>
                        </div>
                    </div>   
            </div>
        </div>
        <div class="logo-search-mine-mask" v-if="routePath !== '/articleLibrary'" :style="{backgroundImage: navBackgroundImage}">
            <div class="logo-search-mine-content">
                <div class="logo-content">
                    <img v-if="logoURL" :src="logoURL">
                    <h1 v-if="!logoURL && navBackgroundImage=='unset'">
                        <span>{{ langTransfer(logoText) }}</span>
                    </h1>
                </div>
            </div>
        </div>
        <div :style="{backgroundColor: themeColor}" class="nav-user-mask">
            <div class="nav-user-content">
                <div class="navs-content">
                    <!--<button @click="homeBtnClick">
                        {{ langTransfer('首页') }}
                    </button>-->
                    <button v-for="(item,index) in navs"
                            :key="index"
                            @click="navItemClick(item,index)"
                            :style="{color:checkedNavIndex==index?navSelectedColor:navsColor}">
                        {{ langTransfer(item.text) }}
                    </button>
                </div>
                <div class="search-content-box">
                    <div :style="{ opacity: navs[checkedNavIndex].text === '客户端' ? 0 : '',
                                   height:navs[checkedNavIndex].text === '客户端' ? 0 : '' }"
                         class="search-content" :class="{'search-content-magazine440':navs[checkedNavIndex].text=='期刊'}">
                        <div class="search-input-mask" :class="{'search-content-magazine400':navs[checkedNavIndex].text=='期刊'}">
                            <div class="search-type" v-if="navs[checkedNavIndex].text=='期刊'">
                                <div class="search-type-text">
                                    <div>
                                        {{selectSearchObj.name}}
                                        <i class="select-icon" :style="{borderTop:'5px solid '+themeColor}"></i>
                                    </div>
                                </div>
                                <div class="search-type-list">
                                    <ul>
                                        <li v-for="(item,index) in magazinesearchtextlist" 
                                        @mouseenter="hoverSearchIndex = index" 
                                        @mouseleave="hoverSearchIndex = -1" :style="{background: hoverSearchIndex === index ? themeColor : ''}" @click="selectsearchtype(index)">{{item.name}}</li>
                                    </ul>
                                </div>
                            </div>
                            <input v-model="searchWord"
                                   :placeholder="langTransfer(`搜${
                                   navs[checkedNavIndex].text === '音频' ? '条': '本'}${navs[checkedNavIndex].text}试试`)"
                                   type="input"
                                   @keyup.enter="goSearchResult">
                        </div>
                        <div
                             class="search-icon"
                             @click="goSearchResult" >
                            <img src="@/assets/search.png">
                        </div>
                    </div>  
                    <div class="search-adv" v-if="navs[checkedNavIndex].text=='期刊'" @click="goadvsearch">高级搜索</div>   
                </div>
                
               
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        components: {
        },
        data () {
            return {
                navsMap: {
                    magazine: {
                        text: '期刊',
                        routeName: 'magazine'
                    },
                    book: {
                        text: '图书',
                        routeName: 'book'
                    },
                    audio: {
                        text: '音频',
                        routeName: 'audio'
                    },
                    video: {
                        text: '视频',
                        routeName: 'video'
                    },
                    newspaper: {
                        text: '报纸',
                        routeName: 'newspaper'
                    },
                    articleLibrary: {
                        text: '文库',
                        routeName: 'articleLibrary'
                    }
                },
                checkedNavIndex: 0,
                isSimpleConversion: true,
                searchWord: '',
                showMoreActvies: false,
                moreActives: [
                    // {
                    //     text: '我的收藏',
                    //     routeName: 'collection'
                    // },
                    // {
                    //     text: '我的书架',
                    //     routeName: 'bookCase'
                    // },
                    {
                        text: '账号设置',
                        routeName: 'userSetting'
                    },
                    {
                        text: '退出登录'
                    }
                ],
                hoverActivesIndex: -1,
                hoverSearchIndex:-1,
                selectSearchObj:{name:'刊名',type:-1},
                magazinesearchtextlist:[{name:'刊名',type:-1},{name:'标题',type:0},{name:'全文',type:1}],
                carsiimg:require('@/assets/carsi.png')
            }
        },
        computed: {

            extensionTopUrls()
            {
                const { globalNavsData,extensionTopURL} = this.$store.state
                const arr = [];
                if(extensionTopURL)
                {
                    let urls = extensionTopURL.split(',')
                    for (var i = 0; i < urls.length; i++) {
                        let uarr = urls[i].split('|');
                        arr.push({
                            text: uarr[0],
                            routeName: uarr[1]
                        })
                    }                   
                }
                return arr;
            },
            navs () {
                const { globalNavsData,extensionURL} = this.$store.state
                const arr = []
                globalNavsData.forEach((e) => {
                    arr.push(this.navsMap[e])
                })
                // if (arr.length > 0) {
                if (this.isNexus.includes('client')) {
                    arr.push({
                        text: '客户端',
                        routeName: 'downloadClient'
                    })
                }
                if(extensionURL)
                {
                    let urls = extensionURL.split(',')
                    for (var i = 0; i < urls.length; i++) {
                        let uarr = urls[i].split('|');
                        arr.push({
                            text: uarr[0],
                            routeName: uarr[1]
                        })
                    }                   
                }
                // } else {
                //     arr = [{
                //         text: ''
                //     }]
                // }
                return arr
            },
            routePath () {
                return this.$route.path
            },
            userInfos () {
                return this.$store.state.userInfos
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            logoText () {
                return this.$store.state.serviceName
            },
            logoURL () {
                return this.$store.state.logoURL
            },
            logoURL () {
                return this.$store.state.logoURL
            },
            isNexus () {
                return this.$store.state.isNexus
            },
            navBackgroundImage () {
                return this.$store.state.navBackgroundImage?'url('+this.$store.state.navBackgroundImage+')':'unset'
            },
            navsColor()
            {
                return this.$store.state.navsColor;
            },
            navSelectedColor()
            {
                return this.$store.state.navSelectedColor;
            },
            enableCastLogin()
            {
                return this.$store.state.enableCastLogin;
            }

        },
        watch: {
            routePath () {
                this.initCheckedNavIndex()
            },
            navs () {
                this.initCheckedNavIndex()
            }
        },
        mounted () {
            this.initCheckedNavIndex()
            this.initlangType()

        },
        methods: {
            goadvsearch()
            {
                this.$router.push({
                    name: 'advancedSearch'
                })
            },
            selectsearchtype(index)
            {
                this.selectSearchObj = this.magazinesearchtextlist[index];
            },
            homeBtnClick () {
                const item = this.navs[0]
                this.navItemClick(item, 0)
            },
            navItemClick (item, index) {
                this.checkedNavIndex = index
                const { routeName } = item
                if (routeName) {
                    if(routeName.toLowerCase().indexOf('http://')!=-1 && routeName.toLowerCase().indexOf('http://')!=-1){
                        window.location.href = routeName;
                        return;
                    }
                    this.$router.push({
                        name: routeName
                    })
                }
            },
            showLoginRegister () {
                this.$store.commit('setShowLoginRegister', true)
            },
            initCheckedNavIndex () {
                let { path } = this.$route
                path = path.toLocaleLowerCase()
                this.checkedNavIndex = this.navs.findIndex((e) => {
                    if (!e.routeName) {
                        return false
                    }
                    const routeName = e.routeName ? e.routeName.toLocaleLowerCase() : ''
                    return path.search(routeName) !== -1
                })
                this.checkedNavIndex = this.checkedNavIndex === -1 ? 0 : this.checkedNavIndex
            },
            goSearchResult () {
                const { searchWord, navs, checkedNavIndex } = this;
                let resourceType = navs[checkedNavIndex].routeName;
               
                if (searchWord) {
                    this.searchWord = ''
                    if((this.selectSearchObj.type==0 ||
                    this.selectSearchObj.type==1) && resourceType=='magazine'){
                        // this.$router.push({
                        //     name:'advancedSearchResults',  
                        //     params:{
                        //         sourcetype:1,
                        //         pageNumber:1,
                        //         magazineName:'magazineName',
                        //         magazineNameLogic:0,
                        //         year:0,
                        //         yearLogic:0,
                        //         issue:0,
                        //         issueLogic:0,
                        //         title:this.selectSearchObj.type==0?searchWord:'title',
                        //         titleLogic:0,
                        //         content:this.selectSearchObj.type==1?searchWord:'content',
                        //         contentLogic:0,
                        //         minDate:'minDate',
                        //         minDateLogic:0,
                        //         maxDate:'maxDate',
                        //         maxDateLogic:0,                        
                        //         sortType:0,
                        //     }
                        // });
                         this.$router.push({
                            name:'advancedSearchResults',  
                            params:{
                                sourcetype:"sourcetype",
                                pageNumber:1,
                                magazineName:'magazineName',
                                magazineNameLogic:"magazineNameLogic",
                                year:"year",
                                yearLogic:"yearLogic",
                                issue:"issue",
                                issueLogic:"issueLogic",
                                title:this.selectSearchObj.type==0?searchWord:'title',
                                titleLogic:"titleLogic",
                                content:this.selectSearchObj.type==1?searchWord:'content',
                                contentLogic:"contentLogic",
                                minDate:'minDate',
                                minDateLogic:"minDateLogic",
                                maxDate:'maxDate',
                                maxDateLogic:"maxDateLogic",                        
                                sortType:"sortType",
                            }
                        });
                    }else{
                        this.$router.push({
                            name: 'searchResults',
                            params: {
                                resourceType,
                                searchWord
                            }
                        })                        
                    }
                }
            },
            moreActivesClick (item) {
                const { routeName } = item;
                if(routeName)
                {
                    window.location.href=`/account/mylibrary/default.html?templatename=weblibrary&virtualpath=${sessionStorage.getItem("virtualPath")}&pagename=${routeName}`;
                    return;
                }else {
                    this.logout()
                }
            },
            async logout () {
                try {
                    const data = await this.$apis('user').logout()
                    if (data.Code === 1) {
                        // const ticket = this.$cookies.get('baseTicket')
                        // this.$cookies.set('ticket', ticket)
                        this.$cookies.remove('user')
                        this.$store.commit('setUserInfos', undefined);
                        if(data.Data){
                            window.location.href = data.Data;
                        }else{
                            window.location.reload()
                        }  
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            changeLanType (typeName) {
                if (typeName === 'simple') {
                    this.$cookies.remove('lang')
                    this.isSimpleConversion = true
                } else {
                    this.$cookies.set('lang', 'zh-Hant')
                    this.isSimpleConversion = false
                }
                window.location.reload()
            },
            initlangType () {
                const langType = this.$cookies.get('lang')
                this.isSimpleConversion = !langType
            },
            goMine (target) {
                const userInfos = this.$cookies.get('user')
                if (userInfos) {
                    /*this.$router.push({
                        name: target
                    })*/
                    window.location.href=`/account/mylibrary/default.html?templatename=weblibrary&virtualpath=${sessionStorage.getItem("virtualPath")}&pagename=${target}`;
                } else {
                    this.$store.commit('setShowLoginRegister', true)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .search-content-magazine440{
        width: 440px !important;
    }
    .search-content-magazine400{
         width: 400px !important;
    }

    .global-header {
        width: 100%;
        height: 120px;
        min-width: 1140px;
        position: fixed;
        left: 0;
        top: 0;
        z-index: 1;

        .nav-user-mask {
            width: 100%;
            height: 40px;
            background: #0084FF;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        }
        .nav-top-mask{
            width: 100%;
            height: 40px;
            background: #f1f1f1;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            button{
                color: black;
            }
            span{color: black;}
            .usercollection{
                button{
                    margin-left: 30px !important;
                     margin-right:unset;
                }
            }
        }

        .logo-search-mine-mask {
            width: 100%;
            height: 80px;
            background: #FFFFFF;
            box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
            background-repeat: no-repeat;
            background-size: cover;
        }
    }

    .nav-user-content {
        width: 1140px;
        margin: 0 auto;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        line-height: 40px;
        .search-content-box{
            display: flex;
            flex-wrap: nowrap;
            justify-content: end;
            align-items: center;
            &>.search-adv{
                margin-left: 5px;
                cursor: pointer;
            }
        }
        .search-content {
            width: 340px;
            height: 30px;
            overflow: hidden;
            background: #F6F6F6;
            /*border: 1px solid #EBEBEB;
            border-radius: 4px;*/
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .search-input-mask {
                width: 300px;
                height: 40px;
                box-sizing: border-box;
                margin: 0;
                //padding: 0 12px;
                
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                align-items: center;

                &>.search-type{
                    font-size: 14px;
                    &:hover .search-type-list{
                        visibility: unset;
                    }
                    flex:1;
                    color: black;
                    text-align: center;
                    cursor: pointer;
                    &>.search-type-text{
                        height: 30px;

                        display: flex;
                        justify-content: center;
                        align-items: center;
                        &>div:first-child{
                            height: 20px;
                            line-height: 20px;
                            border-right: 1px solid #dbdbdb;
                            width: 100%;
                            &>.select-icon {
                                vertical-align: middle;
                                display: inline-block;
                                width: 0;
                                height: 0;
                                border-left: 4px solid transparent;
                                border-right: 4px solid transparent;
                                border-top: 5px solid black;
                                transition: transform 0.2s;
                            }
                            
                        }

                    }

                    &>div.search-type-list{
                        visibility:hidden;
                        width: 69px;
                        background:#F6F6F6;
                        position:absolute;
                        z-index: 9;
                        border-radius:0 0 5px 5px;
                        &>ul{
                            list-style: none;
                            padding:3px 3px;
                            margin:0;
                            &>li{

                                text-align: center;
                                &:hover{
                                    color: white;
                                }
                            }
                        }
                    }
                }
            }

            input {
                width: 330px;
                height: 30px;
                font-size: 14px;
                line-height: 1em;
                color: #8590A6;
                padding-left: 10px;
                box-sizing: border-box;
            }

            .search-icon {
                width: 40px;
                height: 40px;
                background: #c1c1c1;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }
        }
        .navs-content {
            //width: 388px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }

        button {
            
            font-size: 16px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 40px;
            margin-right: 30px;
        }
        .user-area{
            display: flex;
            .login-user {
                button{
                    margin-right: 0 !important;
                }
            }
        }

        .user-content {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            button {
                margin-right: 0;
            }

            .extensionTopUrls{
                margin-left: 10px;
            }
            span {
                margin: 0 6px;
            }
        }
    }

    .user-infos {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        width: 139px;
        position: relative;
        cursor: pointer;

        .user-avatar {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            background-repeat: no-repeat;
            background-size: cover;
            background: #f6f6f6;
        }

        p {
            margin: 0 8px 0 10px;
            color: black;
        }

        .select-icon {
            width: 0;
            height: 0;
            border-left: 4px solid transparent;
            border-right: 4px solid transparent;
            border-top: 5px solid black;
            transition: transform 0.2s;
        }

        .more-actives-mask {
            width: 100%;
            height: auto;
            position: absolute;
            top: 40px;
            left: 0;
            background: #FFFFFF;
            overflow: hidden;
            max-height: 0;
            border-radius: 4px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12), 0 0 6px 0 rgba(0,0,0,0.04);
            border: none;
            transition: max-height .2s ease-in;
        }

        .more-actives {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            border: 1px solid #D6DCE2;
            border-radius: 2px;

            button {
                width: 100%;
                height: 36px;
                padding-left: 10px;
                font-size: 14px;
                color: #475669;
                letter-spacing: 0;
                line-height: 14px;
                text-align: left;
            }

            button:first-child {
                margin-top: 8px;
            }

            button:last-child {
                margin-bottom: 8px;
            }

            button:hover {
                color: #fff;
            }
        }

        .more-actives-showed {
            max-height: 160px;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,0.12), 0 0 6px 0 rgba(0,0,0,0.04);
        }
    }

    .logo-search-mine-content {
        width: 1140px;
        margin: 0 auto;
        height: 80px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        .logo-content {
            width: 370px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            overflow: hidden;

            img {
                height: 40px;
                margin-right: 8px;
            }

            h1 {
                font-size: 20px;
                color: #000000;
                letter-spacing: 0;
                line-height: 20px;
            }
        }



        .mine-content {
            width: 218px;
            margin-left: 161px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .mine-item {
                width: 99px;
                height: 40px;
                box-sizing: border-box;
                padding: 0 10px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                border: 1px solid #8590A6;
                border-radius: 4px;
                
                font-size: 14px;
                color: #8590A6;
                cursor: pointer;
            }
        }
    }
</style>
